import React, { useEffect, useState } from 'react';
import StepOne from 'components/organisms/RegisterSteps/StepOne';
import StepTwo from 'components/organisms/RegisterSteps/StepTwo';
import StepThree from 'components/organisms/RegisterSteps/StepThree';
import StepFour from 'components/organisms/RegisterSteps/StepFour';
import StepFive from 'components/organisms/RegisterSteps/StepFive';
import StepSix from 'components/organisms/RegisterSteps/StepSix';
import StepSeven from 'components/organisms/RegisterSteps/StepSeven';
import StepEight from 'components/organisms/RegisterSteps/StepEight';
import StepNine from 'components/organisms/RegisterSteps/StepNine';
import StepTen from 'components/organisms/RegisterSteps/StepTen';
import { Container, Grid } from '@material-ui/core';
import BoxWrapper from 'components/atoms/BoxWrapper';
import CustomizedStepper from 'components/atoms/Stepper';
import HeaderTemplate from 'templates/HeaderTemplate/HeaderTemplate';

const RegisterPage = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone_number: '',
        birth_date: '',
        postcode: '',
        gender: '',
        ethnicity: '',
        type_of_support: '',
        carers_allowance: '',
        care_needs: '',
        support: [],
        notification_time: '',
        notification_option: '',
        privacy_policy: 1,
    });

    const [Step, setStep] = useState({ currentStep: 'stepOne', stepNumber: 0 });

    const Steps = {
        stepOne: StepOne,
        stepTwo: StepTwo,
        stepThree: StepThree,
        stepFour: StepFour,
        stepFive: StepFive,
        stepSix: StepSix,
        stepSeven: StepSeven,
        stepEight: StepEight,
        stepNine: StepNine,
        stepTen: StepTen,
    };

    const CurrentStep = Steps[Step.currentStep];

    const setValuesToFormData = (values) => {
        setFormData({
            ...formData,
            ...values,
        });
    };

    const nextStep = (value, stepNumber) => {
        setStep((prevState) => ({
            currentStep: value,
            stepNumber: stepNumber || prevState.stepNumber + 1,
        }));
    };

    useEffect(()=>{
        window.scrollTo(0,0);
    },[Step.currentStep]);

    return (
        <>
            <HeaderTemplate title="Sign Up" />
            <CurrentStep
                setValuesToFormData={setValuesToFormData}
                nextStep={nextStep}
                data={formData}
            />
            <Container>
                <BoxWrapper mt="10" mb="25">
                    <Grid container justify="center">
                        <Grid item xs={12} md={4}>
                            <CustomizedStepper
                                steps={Steps}
                                activeStep={Step.stepNumber}
                                data={formData}
                            />
                        </Grid>
                    </Grid>
                </BoxWrapper>
            </Container>
        </>
    );
};

export default RegisterPage;
